import type { Question } from '../../types'

export function shouldShowSchoolApprovedBadge (
  isEditable: boolean | undefined,
  isSurveyTemplate: boolean,
  isAcademicRoute: boolean,
  isFollowUpQuestion: boolean,
  question: Question
): boolean {
  const approved = typeof question.isActuallySchoolApproved === 'boolean'
    ? question.isActuallySchoolApproved
    : question.isSchoolApproved
  return (isEditable === false || isSurveyTemplate || isAcademicRoute) &&
    !isFollowUpQuestion &&
    (isSurveyTemplate || !!approved)
}
